// extracted by mini-css-extract-plugin
export var cookie = "footer-module--cookie--TAg7N";
export var websitePolicy = "footer-module--websitePolicy--X31c8";